export default __webpack_public_path__ + "list-add.890797598a30d31b.svg";